import React from 'react';
import cx from 'clsx';
import styles from '../GameDetailsTop.module.scss';
import { GameTileProps } from '../../../modular-grid/types';
import AssetLayer from '../../../AssetLayer';
import { LayersWrapper } from '../../../game-tile';
import { isEqual } from 'src/utils/lodash-alternatives';
interface GameDetailsMultipleImagesPropTypes {
  images: GameTileProps['infoPageImages'];
  title: string;
}

const GameDetailsMultipleImages: React.FC<GameDetailsMultipleImagesPropTypes> = React.memo(
  ({ images, title }) => {
    if (!images) return null;
    return (
      <>
        <div
          data-testid="game-details-header-image"
          className={cx(styles.image, styles.imageBig)}
        >
          <div
            data-testid="game-details-header-image-overlay"
            className={cx(styles.overlay)}
          >
            <LayersWrapper>
              <AssetLayer
                type="image"
                sizedSources={images.background}
                rounded="none"
                alt={title}
              />
            </LayersWrapper>
          </div>
          <img
            data-testid="game-details-header-logo"
            alt="logo"
            className={styles.logo}
            src={images.logo.source.retina || images.logo.source.normal}
          />
        </div>
      </>
    );
  },
  (
    prevProps: GameDetailsMultipleImagesPropTypes,
    nextProps: GameDetailsMultipleImagesPropTypes
  ) => isEqual(prevProps, nextProps)
);

export default GameDetailsMultipleImages;
